import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';

import './styles.css';

class FormFooter extends Component {
	constructor(props) {
        super(props)

        this.state = {
            showRemoveConfirmation: false,
        }
    }

    _toggleRemoveConfirmation = () => {
        this.setState({ showRemoveConfirmation: !this.state.showRemoveConfirmation })
    }

    render() {
        const { entityName, onCancel, onRemove, invalid } = this.props
        const { showRemoveConfirmation } = this.state

        if (showRemoveConfirmation) {
            return (
                <div className="FormFooter FormFooter--confirmation">
                    <Button 
                        className="FormFooter-button"
                        type="button"
                        skin="gray-light"
                        text="Cancelar"
                        onClick={this._toggleRemoveConfirmation}
                    />
                    <Button 
                        className="FormFooter-button"
                        type="button"
                        skin="danger"
                        text="Confirmar remoção"
                        onClick={onRemove}
                    />
                </div>
            )
        } else {
            return (     
                <div className={'FormFooter' + (!onRemove ? ' FormFooter--confirmation' : '')}>
                    {
                        onRemove &&
                        <div>
                            <Button 
                                className="FormFooter-button"
                                type="button"
                                skin="danger"
                                text={"Remover " + entityName}
                                onClick={this._toggleRemoveConfirmation} 
                            />
                        </div>
                    }
                    <div>
                        <Button 
                            className="FormFooter-button"
                            type="button"
                            skin="gray-light" 
                            text="Cancelar"
                            onClick={onCancel} 
                        />
                        <Button 
                            disabled={invalid}
                            className="FormFooter-button"
                            type="submit"
                            skin="primary"
                            text="Salvar"
                        />
                    </div>
                </div>   
            )
        }
    }
}

FormFooter.propTypes = {
    entityName: PropTypes.string,
    onCancel: PropTypes.func,
    onRemove: PropTypes.func,
    invalid: PropTypes.bool,
}

export default FormFooter
